import React from "react";
import * as aor from "react-admin";
import { Button, Fade, Divider, Snackbar } from "@material-ui/core";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import RichTextInput from "ra-input-rich-text";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TranslatedText from "./TranslatedText";
import CircularProgress from "@material-ui/core/CircularProgress";

class EmailSender extends React.Component {
    state = { message: "", address: null, error_msg: "", loading: false };

    handleClick = () => {
        this.setState({
            showSnackBar: false,
            error: false,
            error_msg: "",
            loading: true
        });
        const message = this.state.message;

        const resource_id = this.state.resource_id;
        const action = "sendEmail";
        const addressee = [this.state.address];
        const licenses = [];
        // body is handmade including message and the checkbox selected
        // resource_id, action are mandatory and hardcoded
        const body = {
            data: { message, resource_id, action, addressee, licenses }
        };
        myRestClient("CREATE", "email", body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,
                    message: "",
                    addressee: [],
                    licenses: [],
                    error_msg: "",
                    loading: false
                });
                this.state.onCloseDialog();
            },
            e => {
                this.setState({
                    showSnackBar: true,
                    error: true,
                    error_msg: e.message,
                    loading: false
                });
                this.state.onCloseDialog();
            }
        );
    };

    handleMessageChange = e => {
        var msg_value_html = Object.keys(e).map(function(key) {
            return e[key];
        });
        msg_value_html.pop();
        msg_value_html = msg_value_html.join("");
        this.setState({ message: msg_value_html });
        return;
    };

    handleClose = () => {
        this.setState({ showSnackBar: false });
    };

    renderSnackMessage() {
        return this.state.error === true ? (
            this.state.error_msg === "mandatory_addressee_licenses" ? (
                <span style={{ color: tccStyles.snackbar.errorColor }}>
                    <TranslatedText resource_name="mandatory_addressee_licenses" />
                </span>
            ) : (
                <span style={{ color: tccStyles.snackbar.errorColor }}>
                    <TranslatedText resource_name="notifactionSentError" />
                </span>
            )
        ) : (
            <span>
                <TranslatedText resource_name="notificationSent" />
            </span>
        );
    }

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={5000}
                onClose={this.handleClose}
                TransitionComponent={Fade}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={this.renderSnackMessage()}
            />
        );
    }
    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog,
            address: this.props.address,
            resource_id: this.props.resource_id,
            onCloseDialog: this.props.onCloseDialog
        });
    }
    renderForm() {
        var toolbarOptions = [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"], // toggled button
            ["clean"]
        ];

        return (
            <div>
                <aor.SimpleForm toolbar={null}>
                    <div style={{ width: "100%" }}>
                        <RichTextInput
                            source="message"
                            toolbar={toolbarOptions}
                            onChange={this.handleMessageChange}
                        />
                        <br />
                        <Divider />
                        <br />
                    </div>
                </aor.SimpleForm>
            </div>
        );
    }
    renderDialog(props) {
        var { showDialog, address } = props;
        var title = "Inviare una mail a " + address;
        return showDialog === true ? (
            <Dialog
                open={showDialog}
                fullScreen={false}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>
                    <b>{title}</b>
                </DialogTitle>
                <DialogContent>{this.renderForm()}</DialogContent>
                <DialogActions>
                    <div
                        align="center"
                        style={{
                            visibility: this.state.loading
                                ? "visible"
                                : "hidden"
                        }}
                    >
                        {<CircularProgress />}
                    </div>
                    {!this.state.loading && (
                        <b>
                            <Button
                                style={{ marginRight: "5px" }}
                                color="primary"
                                variant="contained"
                                onClick={this.handleClick}
                            >
                                <TranslatedText resource_name="send" />
                            </Button>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={this.state.onCloseDialog}
                            >
                                <TranslatedText resource_name="ra.action.cancel" />
                            </Button>
                        </b>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }
    render() {
        return (
            <div>
                {this.renderDialog(this.props)}
                {this.renderSnackBar()}
            </div>
        );
    }
}

export default EmailSender;



// WEBPACK FOOTER //
// ./src/components/EmailSender.js